const calculatePlaceFactor = (stakeFactor: number): string => {
  const roundedStakeFactor = Math.round(stakeFactor * 1000) / 1000;
  const placeFactor = stakeFactor < 1 ? 1 : 1 / roundedStakeFactor;
  return placeFactor.toFixed(3);
};

export { calculatePlaceFactor };
